export enum USER_ACTION_TYPES {
  LOGIN_USER = 'user/LOGIN_USER',
  LOGOUT_USER = 'user/LOGOUT_USER',
}

export enum SEARCH_KEYWORD_ACTION_TYPES {
  SET_SEARCH_KEYWORD = 'user/SET_SEARCH_KEYWORD',
}

export enum SEARCH_KEYWORDS_LIST_ACTION_TYPES {
  SET_SEARCH_KEYWORDS_LIST = 'user/SET_SEARCH_KEYWORDS_LIST',
}
